import React, { useEffect, useState } from "react";
import DatePicker from "react-datepicker";
import "react-datepicker/dist/react-datepicker.css";
import { useSelector } from "react-redux";
const RenderDatePicker = (props) => {
  const [startDateIdt, setStartDateIdt] = useState(null);
  const [startDateRP, setStartDateRP] = useState(null);
  const [endDateRP, setEndDateRP] = useState(null);
  const [startDate, setStartDate] = useState(new Date());

  const { startDate: startDateStore, endDate: endDateStore } = useSelector(
    (store) => store.gstr2a2bNewCommonReducer
  );
  useEffect(()=>{ 
    props.setSelectedToDateRP(endDateStore);
    props.setSelectedFromDateRP(startDateStore);
  },
  [startDateStore, endDateStore])
  const handleChangeRP = ([newStartDate, newEndDate]) => {
    setStartDateRP(newStartDate);
    setEndDateRP(newEndDate);
    props.setSelectedFromDateRP(newStartDate);
      props.setSelectedToDateRP(newEndDate);
  };
  

  const handleInputChange = (e) => {
    e.preventDefault(); // Prevent any change in the input field
  };
  const renderMonthContent = (month, shortMonth, longMonth, day) => {
    const fullYear = new Date(day).getFullYear();
    const tooltipText = `Tooltip for month: ${longMonth} ${fullYear}`;

    return <span title={tooltipText}>{shortMonth}</span>;
  };
  const maxYear = new Date(new Date().getFullYear(), 11, 31);

  return (
    <>
      {props.flag == "InvoiceDate" ? (
        <>
          <div>
            <label
              style={{
                fontFamily: "GT-Walsheim-medium",
                fontSize: "12px",
              }}
            >
              Select Invoice Date
            </label>
            <DatePicker
              selected={startDateIdt}
              onChange={(date) => {setStartDateIdt(date)}}
              placeholderText="Select Invoice Date"
              dateFormat="dd/MM/yyyy"
            />
          </div>
        </>
      ) : props.flag == "singleMonth" ? (
        <>
          <div>
            <label
              style={{
                fontFamily: "GT-Walsheim-medium",
                fontSize: "12px",
              }}
            >
              Select Month
            </label>
            <DatePicker
              selected={new Date()}
              renderMonthContent={renderMonthContent}
              showMonthYearPicker
              dateFormat="MM/yyyy"
              placeholderText="Select Month"
            />
          </div>
        </>
      ) : props.flag == "multipleMonths" ? (
        <>
          <div>
            <label
              style={{
                fontFamily: "GT-Walsheim-medium",
                fontSize: "12px",
              }}
            >
              Select Return Period
            </label>
            <DatePicker
              selected={startDateRP}
              onChange={handleChangeRP}
              // value={storePeriod}
              selectsRange
              startDate={props.selectedFromDateRP}
              endDate={props.selectedToDateRP}
              dateFormat="MM/yyyy"
              showMonthYearPicker
              minDate={startDateStore}
              maxDate={endDateStore}
              onKeyDown={handleInputChange} // Handle any key press
              onKeyPress={handleInputChange}
              placeholderText="Select Return Period"
              InputLabelProps={{
                style: {
                  color: "black",
                  fontFamily: "GT-Walsheim-medium",
                  fontSize: "14px",
                  width: "100%",
                },
              }}
            />
          </div>
        </>
      ) : props.flag == 'singleYear' ?(
        <>
          <div>
            <label
              style={{
                fontFamily: "GT-Walsheim-medium",
                fontSize: "12px",
              }}
            >
              Select Financial Year
            </label>
            <DatePicker
      selected={startDate}
      onChange={(date) => setStartDate(date)}
      showYearPicker
      dateFormat="yyyy"
      // maxDate={maxYear}
    />
          </div>
        </>
      ): console.log("error")}
    </>
  );
};

export default RenderDatePicker;
